module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/17b33f2648d26f48eab60613d2829787.png";